import { DATASTRATEGY, IEntity } from '@proximus/entity-manager';
import { SessionStorageStrategy } from '@proximus/entity-manager/lib/storage/strategies/session-storage.strategy';

export const NortonAccountRegistrationEntity: IEntity<any> = {
  url: '/rest/norton-account-registrations/register',
  requestHeaders: [],
  rel: 'nar:nortonaccountregistrationsmypx',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.CACHE_NETWORK_NO_ERRORS,
  storageStrategy: SessionStorageStrategy.ID,
};
